jQuery(document).ready(function($) {
    // send reset email
    const resetEmailForm = $("#resetEmailForm");
    if ( resetEmailForm ) {
        const resetBtn = $("#resetEmailForm .e-button");
        const resetLoader = $('#resetEmailForm .dot-spin');
        const infoBox = $(".forgotPassPopup .m-popup__error");

        resetEmailForm.submit(function(e) {
            e.preventDefault();
            const formData = $(this).serialize();

            infoBox.hide();

            $.ajax({
                url: main.ajax_url,
                type: "POST",
                dataType: "json",
                data: {
                    form_values: formData,
                    action: "reset_pass_email"
                },
                beforeSend: function() {
                    resetBtn.addClass('active');
                    resetLoader.show();
                },
                complete: function() {
                    resetBtn.removeClass('active');
                    resetLoader.hide();
                },
                success: function(res) {
                    if (res.status == true) {
                        infoBox.addClass("success");
                        infoBox.show().text(res.message);
                    } else {
                        infoBox.removeClass('success');
                        infoBox.show().text(res.message);
                    }
                }
            });
        });
    }

    // reset password
    const resetPasswordForm = $("#resetPasswordForm");
    if (resetPasswordForm) {
        const resetPassBtn = $("#resetPasswordForm .e-button");
        const resetPassLoader = $("#resetPasswordForm .dot-spin");
        const infoPassBox = $(".resetPassPopup .m-popup__error");

        resetPasswordForm.submit(function(e) {
            e.preventDefault();
            const pass1 = $("#pass1").val() || false;
            const pass2 = $("#pass2").val() || false;
            const formData = $(this).serialize();

            infoPassBox.hide();

            $.ajax({
                url: main.ajax_url,
                type: "POST",
                dataType: "json",
                data: {
                    form_values: formData,
                    action: "reset_pass"
                },
                beforeSend: function() {
                    resetPassBtn.addClass("active");
                    resetPassLoader.show();
                },
                complete: function() {
                    resetPassBtn.removeClass("active");
                    resetPassLoader.hide();
                },
                success: function(res) {
                    if (res.status == true) {
                        infoPassBox.addClass("success");
                        infoPassBox.show().text(res.message);
                        resetPasswordForm[0].reset();
                    } else {
                        infoPassBox.removeClass("success");
                        infoPassBox.show().text(res.message);
                    }
                }
            });
        });
    }
});
